import {Component} from "substance"

/**
 * @typedef UIToggle.props
 * @property {string} id - Id of the toggle
 * @property {string} label - The text label
 * @property {boolean} [alignRight=false] - Set to true to have label place to the right
 * @property {boolean} [checked=false] - Wether the toggle is on or off
 * @property {boolean} [checkbox=false] - Set to true to render as checkbox instead of toggle
 * @property {function} [onToggle] - Callback for when the toggle value changes
 */

/**
 * @typedef UIToggle.state
 * @property {bool} checked - If the component is toggled or not
 */

/**
 * Create a simple toggle, or checkbox, component
 *
 * @name UIToggle
 * @class
 *
 * @example
 * import {UIToggle} from 'writer'
 *
 * render($$) {
 *     const el = $$('div')
 *     return el.append(
 *         $$(UIToggle, {
 *             id: 'mytoggle',
 *             label: this.getLabel('My toggle'),
 *             checked: true,
 *             onToggle: (checked) => {
 *                 // Do something
 *             }
 *         })
 *     )
 * }
 *
 * @param {UIToggle.props} props
 * @property {UIToggle.props} props
 * @property {UIToggle.state} state
 */

class ToggleComponent extends Component {

    getInitialState() {
        return {
            checked: this.props.checked === true ? true : false
        }
    }

    onToggle() {
        const checked = !this.state.checked

        if (this.props.onToggle) {
            this.props.onToggle(checked)
        }

        this.extendState({
            checked: checked
        })
    }

    render($$) {
        const toggleGroup = $$('div').addClass('toggle-btn-wrapper'),
            fakeLabel = $$('span').addClass('toggle-btn-fake-label')
                .append(this.props.label)
                .on('click', () => {
                    this.onToggle()
                }),
            label = $$('label').setAttribute('for', this.props.id)
                .addClass(`toggle-btn-label ${this.props.checkbox ? 'checkbox' : ''}`)
                .on('click', (e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    this.onToggle()
                })
            ,
            checkBox = $$('input').setAttribute('type', 'checkbox')
                .addClass('toggle-btn')
                .setAttribute('id', this.props.id)
                .on('focus', (evt) => {
                    label.getComponent().el.el.classList.add('focused')
                })
                .on('blur', (evt) => {
                    label.getComponent().el.el.classList.remove('focused')
                })
                .on('input', (ev) => {
                    this.onToggle();
                })

        if (this.props.tabIndex) {
            checkBox.setAttribute('tabIndex', this.props.tabIndex)
        }


        if (this.state.checked) {
            checkBox.setAttribute('checked', 'checked')
        }
        else {
            checkBox.removeAttribute('checked')
        }

        if (this.props.alignRight) {
            toggleGroup.addClass('align-right')
                .append(fakeLabel)
                .append(checkBox)
                .append(label)

        } else {
            toggleGroup
                .append(checkBox)
                .append(label)
                .append(fakeLabel)
        }

        return $$('div').addClass('np-toggle').append(toggleGroup)
    }
}

export {ToggleComponent}
